<template>
    <div class="home-license-plate" :class="{ 'home-license-plate--empty': empty }">
        <svg v-if="empty" class="home-license-plate__placeholder" viewBox="0 0 157 36" preserveAspectRatio="none" aria-hidden="true">
            <path d="M3 3H154V33H3Z" fill="#cacaca" fill-opacity=".1" />
            <path d="M.5 8V.5H8 M149 .5H156.5V8 M8 35.5H.5V28 M156.5 28V35.5H149" fill="none" stroke="#cacaca" />
            <path d="M78 8V26 M69 17.2578H87" fill="none" stroke="#cacaca" stroke-width="3" vector-effect="non-scaling-stroke" />
        </svg>
        <span v-else class="home-license-plate__number" :class="{ 'home-license-plate__number--segmented': segments }">
            <template v-if="segments"><span v-for="(segment, index) in segments" :key="index">{{ segment }}</span></template>
            <template v-else>{{ number }}</template>
        </span>
    </div>
</template>

<script>
export default {
    name: 'HomeLicensePlate',
    props: { number: { type: String, default: '' }, empty: Boolean },
    computed: {
        segments() {
            // Match the GateOS license-plate component: two letters, four digits, two letters.
            const match = this.number.match(/^([\p{L}]{2})(\d{4})([\p{L}]{2})$/u)
            return match ? [match[1].toUpperCase(), match[2], match[3].toUpperCase()] : null
        }
    }
}
</script>

<style scoped>
@font-face {
    font-family: 'u_DIN 1451 Mittelschrift';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url('@/assets/fonts/uDIN1451Mittelschrift.woff') format('woff');
}
.home-license-plate { width: 100%; aspect-ratio: 670 / 145; display: flex; align-items: center; justify-content: center; padding: 0 5px 0 10%; background: url('@/assets/images/empty-license-plate.png') center / contain no-repeat; container-type: inline-size; }
.home-license-plate__number, .home-license-plate__number span { font-family: 'u_DIN 1451 Mittelschrift', sans-serif; }
.home-license-plate__number { color: #1f2937; font-size: 18px; font-size: 14cqw; font-weight: 600; letter-spacing: .1em; line-height: 1; white-space: nowrap; }
.home-license-plate__number--segmented { display: inline-flex; gap: .15em; }
.home-license-plate--empty { aspect-ratio: 157 / 36; padding: 0; background: none; }
.home-license-plate__placeholder { display: block; width: 100%; height: 100%; }
</style>
